import nopInstance from "../nopInstance.js";

const getCartItemCount = async () => {
  const itemCount = await nopInstance.get("api/cart").then(response => response.data.length);
  return itemCount;
}

const addToCart = async (productId, quantity) => {
  const FD = new FormData();
  FD.append('shoppingCartTypeId', 1)
  FD.append('forceredirection', false)
  FD.append('productId', productId)
  FD.append('qty', quantity)
  const response = await nopInstance.post("ShoppingCart/AddProductToCart_DetailsCustom", FD);
  console.log(response);
  return response;
}

export default {
    getCartItemCount, addToCart,
}